<template>
  <div>
    <stepTitle :navItems="['Live Culture']" :index="1" :step="1"/>
    <div class="container my-4 px-0 py-5" style="background:#fff; min-height:80vh">
      <div v-if="this.$route.name === 'ar_lesson'" class="tag">
        <div class="d-flex justify-content-between">
          <div class="tag-boxes">
            <div class="d-flex" style="position: absolute; bottom:0;">
              <div @click="goLessonPage" :class="{'active':isLesson}" class="tag-body mx-3">{{$t('lessons')}}</div>
              <div v-if="this.$store.state.auth.userRole === 'Teacher'" @click="goResourcePage" :class="{'active':!isLesson}" class="tag-body mx-3">{{$t('teachers_resources')}}</div>
            </div>
          </div>
          <div class="d-flex " style=" margin-right:50px">
          <div class="m-auto type-selecter px-5">
            <font-awesome-icon class="form_icon" :icon="['fas', 'search']" />
            <input v-on:blur="updateSearch" @keyup.enter="updateSearch" v-model="search" style="height:1.5rem" type="text" name="search" class="form_input" placeholder="Search">
          </div>
            <img class="back-icon pointer my-4" @click="previousPage" style="height:20px" src="../../../assets/image/icon/close_lesson.png" />
          </div>
        </div>
      </div>
      <router-view :inputSearchTxt="searchTxt"></router-view>
    </div>
  </div>
</template>

<script>
import stepTitle from '../../Teacher/StepTitle'
export default {

  name: 'ARLayout',

  data () {
    return {
      search: '',
      searchTxt: '',
      isLesson: true
    }
  },
  mounted () {
    // console.log(this.$store.state.auth)
    // if (!this.$store.state.auth) {
    //   this.$router.push({name: 'login'})
    // }
  },
  methods: {
    goLessonPage () {
      this.search = ''
      this.searchTxt = ''
      this.$router.push({name: 'ar_lesson', params: {id: this.$route.params.id, page: 1}})
    },
    goResourcePage () {
      this.$router.push({name: 'ar_download', params: {id: this.$route.params.id}})
    },
    previousPage () {
      this.$router.go(-1)
      if (this.$route.name === 'ar_download') {
        this.isLesson = true
      } else {
        this.isLesson = false
      }
    },
    updateSearch () {
      this.searchTxt = this.search
    }
  },
  components: {
    stepTitle
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/style/color.scss";
.tag {
    text-align: left;
    border-bottom: #bbbbbb solid 2px;
    .tag-boxes {
      margin-left: 60px;
      position: relative;
    }
  }
  .tag-body {
    white-space:nowrap;
		cursor: pointer;
    display: inline-block;
    padding: 2px 10px;
    border-radius: 10px 10px 0 0;
    border-top: 2px #c7c7c7 solid;
    border-right: 2px #c7c7c7 solid;
    border-left: 2px #c7c7c7 solid;
    color: #000000;
		&:hover {
      background-color: #c7c7c7;
    }
	}
  .active {
    border-radius: 10px 10px 0 0;
    background-color: #c7c7c7;
  }
  @media only screen and (max-width: 768px) {
    .type-selecter {
      position: absolute;
      left: 20px;
    }
  }
</style>


// WEBPACK FOOTER //
// ARLayout.vue?55791d7a